import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import { format } from "date-fns";

import GenericTableComponent from "../../components/common/Table";
import { getAllPostBacks } from "../../redux/slices/postbackSlice";
//import { convertToLocalCurrency } from '../../utils/currency';

const columns = [
  { id: "postbackCampaign", label: "Campaign" },
  { id: "postbackUser", label: "Publisher" },
  { id: "createdAt", label: "Date" },
  { id: "transactionId", label: "Click Id" },
  { id: "msisdn", label: "Msisdn" },
  { id: "publisherCPA", label: "Publisher CPA" },
  { id: "campaignCPA", label: "Campaign CPA" },
  { id: "status", label: "Status" },
  // { id: "userActive", label: "Status" },
];
const PostbackTable = () => {
  const dispatch = useDispatch();
  const { postbacks, meta, loading } = useSelector((state) => state.postback);
  //console.log(meta)
  
//console.log(postbacks)
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    return {
      startDate: now,
      endDate: now,
    };
  });

  useEffect(() => {
    const params = { page, rowsPerPage };

    if (dateRange.startDate && dateRange.endDate) {
      params.startDate = format(dateRange.startDate, "yyyy-MM-dd");
      params.endDate = format(dateRange.endDate, "yyyy-MM-dd");
    }

    if (searchFilter) {
      params.name = searchFilter;
    }

    dispatch(getAllPostBacks(params));
  }, [dateRange, dispatch, page, rowsPerPage, searchFilter]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
  };
  
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        setSearchFilter(searchTerm);
        setPage(0);
      }, 2000),
    [setSearchFilter, setPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };
  
  const triggerSearch = () => {
    setSearchFilter(search);
    setPage(0);
  };

  // const handleFilterChange = (value) => {
  //   // let boolValue;
  //   // if (value === "ACTIVATED") {
  //   //   boolValue = true;
  //   // } else if (value === "DEACTIVATED") {
  //   //   boolValue = false;
  //   // } else {
  //   //   boolValue = null;
  //   // }
  //   dispatch(getAllPostBacks({ page: 0, rowsPerPage, state: value }));
  // };

  // const handleActiveState = (id) => {
  //   dispatch(statusAdvertiser(id))
  //   .unwrap()
  //   .then(() => {
  //     dispatch(getAllPostBacks({ page, rowsPerPage }));
  //   })
  //   .catch((error) => {
  //     console.error("Failed to update advertiser status:", error);
  //   });
  // };

  return (
    <div>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={postbacks}
          postbackView
          filterSearch={true}
          paginate={true}
          viewLink="/view-advertiser"
          editLink="/edit-advertiser"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          setDateRange={setDateRange}
          dateRange={dateRange}
          //hideSearch
          hideActiveSearch
          // onFilterChange={handleFilterChange}
          // handleActiveState={handleActiveState}
        />
      )}
    </div>
  );
};

export default PostbackTable;
